export default "__VITE_ASSET__DGGyxFrU__"